import { render, staticRenderFns } from "./Mvr.vue?vue&type=template&id=b4b41b48"
import script from "./Mvr.vue?vue&type=script&lang=js"
export * from "./Mvr.vue?vue&type=script&lang=js"
import style0 from "./Mvr.vue?vue&type=style&index=0&id=b4b41b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports